<template>
  <div class="home_content">
    <!-- 顶部 -->
    <div class="top">
      <TopContent />
    </div>
    <!-- 内容 -->
    <div class="pc-sections" v-if="!isMobile">
      <full-page ref="fullpage" :options="options">
        <div class="section top_bg">
        </div>
        <div class="section pageCon about_bg">
          <div class="pageCon_bg  ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2">关于我们</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom">

                随 着 各 类 高 端 CT、M R、P E T- CT、四 维 彩 超 级 装 备 的 普 及，临 床 影 象 数 据 动 辄
                数 百 兆 大 小，还 包 括 三 维 后 处 理，高 清 动 态 影 像 等 特 殊 效 果，已 无 法 经 过 几 张 传 统
                胶片来展现。<br><br>
                惠合云电子胶片系统是将患者的影像检查报告和全部的DICOM影像存储在
                云 端 的，通 过 二 维 码、公 众 号 等 多 种 梁 道 在 多 种 终 端 设 备 上 调 阅 浏 览 和 下 载，让 医
                疗 数 据 全 方 位 的 展 现，具 有 真 正 的 临 床 诊 断 参 考 价 值 。通 过 影 像 二 维 码 授 权 可 满 足
                患 者 二 次 问 诊 需 求，同 时 借 助 云 平 台 强 大 后 处 理 技 术 协 助 医 生 可 在 线 对 影 像 的 进 行
                常规浏览及特殊操作。<br><br>
                患 者 可 通 过 关 注 医 院 公 众 号 获 取 个 人 健 康 档 案，包 含 患 者 放 射 影 像 个 人 检 查
                资 料 和 诊 断 报 告，在 患 者 获 取 个 人 健 康 档 案 同 时 可 向 本 院 医 生 发 起 报 告 解 读、二 次
                问 诊 需 求，由 本 院 医 生 通 过 公 众 号 在 线 为 患 者 提 供 报 告 解 读 和 二 次 问 诊 服 务 并 出 具咨询建议，极大提升了患者的就诊体验。
              </div>
            </div>
            <div class="pageRight">
              <img src="../assets/img/About_lou.png" class="abimg" />
            </div>
          </div>
        </div>
        <div class="section pageCon product">
          <div class="pageCon_bg  ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2">产品列表</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom">
                <div class="items-container">
                  <div v-for="(item, index) in items" :key="index" class="item">
                    <div class="image-container">
                      <img :src="item.image" :alt="item.title" class="item-image">
                    </div>
                    <!-- <div class="title-container">
                      <h3 class="item-title">{{ item.title }}</h3>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section pageCon honor">
          <div class="pageCon_bg  ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2 whiteFont">平台传输方式</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom" style="color: white;">
                <h3 style="font-weight: bold;">传输技术（DICOM3.0原图无损传输）</h3>

                <p>
                  <br>
                  专利名称：<br>
                  多中继互联网大数据推送方法和系统<br><br>
                  专利号：ZL 2016 1 0111050.6
                </p>
              </div>
            </div>
            <div class="pageRight">
              <div class="imgs">
                <img src="../assets/img/honor2.png" class="img1" />
              </div>
            </div>
          </div>
        </div>
        <div class="section pageCon ">
          <div class="pageCon_bg  ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2">业务流程</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom">
                <div class="img_s1">
                  <img src="../assets/img/yewu.png" width="100%" height="100%" />
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="section pageCon ">
          <div class="pageCon_bg  ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2">平台接入方式</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom">
                <div class="img_s2">
                  <div><img src="../assets/img/jieru.png" width="100%" height="50%" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section pageCon ">
          <div class="pageCon_bg ">
            <div class="pageLeft fontsize1">
              <div class="LeftTit">
                <div class="Tittext fontsize2 ">合作伙伴</div>
                <div class="blue"></div>
              </div>
              <div class="LeftBottom">
                <div class="container">
                  <div class="top-section">
                    <div class="image-container">
                      <img v-for="(img, index) in images" :key="index" :src="img" class="image-item">
                    </div>
                  </div>
                  <div class="hospital-section">
                    <div class="hospital-column" v-for="(column, colIndex) in hospitalData" :key="'col-' + colIndex">
                      <div v-for="(item, rowIndex) in column" :key="'item-' + colIndex + '-' + rowIndex"
                        class="hospital-name">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <div class="section bottom">
          <BottomContent />
        </div>
      </full-page>
    </div>
    <div class="mobile-sections">
      <div class="m_con_bg top_bg">
      </div>
      <div class="m_con about_bg">
        <div class="m_bule_div">
          <div class="blue_tit">关于我们</div>
          <div class="blue_color blue_div"></div>
        </div>
        <div class="m_about">
          <p class="m_about_text">
            随 着 各 类 高 端 CT、M R、P E T- CT、四 维 彩 超 级 装 备 的 普 及，临 床 影 象 数 据 动 辄
            数 百 兆 大 小，还 包 括 三 维 后 处 理，高 清 动 态 影 像 等 特 殊 效 果，已 无 法 经 过 几 张 传 统
            胶片来展现。<br><br>
            惠合云电子胶片系统是将患者的影像检查报告和全部的DICOM影像存储在
            云 端 的，通 过 二 维 码、公 众 号 等 多 种 梁 道 在 多 种 终 端 设 备 上 调 阅 浏 览 和 下 载，让 医
            疗 数 据 全 方 位 的 展 现，具 有 真 正 的 临 床 诊 断 参 考 价 值 。通 过 影 像 二 维 码 授 权 可 满 足
            患 者 二 次 问 诊 需 求，同 时 借 助 云 平 台 强 大 后 处 理 技 术 协 助 医 生 可 在 线 对 影 像 的 进 行
            常规浏览及特殊操作。<br><br>
            患 者 可 通 过 关 注 医 院 公 众 号 获 取 个 人 健 康 档 案，包 含 患 者 放 射 影 像 个 人 检 查
            资 料 和 诊 断 报 告，在 患 者 获 取 个 人 健 康 档 案 同 时 可 向 本 院 医 生 发 起 报 告 解 读、二 次
            问 诊 需 求，由 本 院 医 生 通 过 公 众 号 在 线 为 患 者 提 供 报 告 解 读 和 二 次 问 诊 服 务 并 出 具咨询建议，极大提升了患者的就诊体验。
          </p>
          <div class="m_about_img">
            <img src="../assets/img/About_lou.png" />
          </div>
        </div>
      </div>
      <div class="m_con product">
        <div class="m_bule_div">
          <div class="blue_tit">产品列表</div>
          <div class="blue_color blue_div"></div>
        </div>
        <div class="m_items-container">
          <div v-for="(item, index) in items" :key="index" class="item">
            <div class="image-container">
              <img :src="item.image" :alt="item.title" class="item-image">
            </div>
            <!-- <div class="title-container">
              <h3 class="item-title">{{ item.title }}</h3>
            </div> -->
          </div>
        </div>
      </div>
      <div class="m_con honor">
        <div class="m_bule_div">
          <div class="blue_tit white_text">平台运输方式</div>
          <div class="blue_color blue_div"></div>
        </div>
        <div class="m_honor">
          <!-- <img src="../assets/img/honor1.png" class="m_honorimg1" /> -->
          <img src="../assets/img/honor2.png" class="m_honorimg2" />
          <!-- <img src="../assets/img/honor3.png" class="m_honorimg3" /> -->
        </div>
      </div>
      <div class="m_con product">
        <div class="m_bule_div">
          <div class="blue_tit">合作伙伴</div>
          <div class="blue_color blue_div"></div>
        </div>
        <div class="m_container">
          <div class="top-section">
            <div class="image-container">
              <img v-for="(img, index) in images" :key="index" :src="img" class="image-item">
            </div>
          </div>
          <div class="hospital-section">
            <div class="hospital-column" v-for="(column, colIndex) in mhospitalData" :key="'col-' + colIndex">
              <div v-for="(item, rowIndex) in column" :key="'item-' + colIndex + '-' + rowIndex" class="hospital-name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" bottom">
        <BottomContent />
      </div>
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {
      loading: false,
      actype: "home",
      showtop: true,
      imgList: [],
      ismdd: false,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        fixedElements: "#Navbar",
        anchors: ["page1", "page2", "page3", "page4", "page5", "page6", "page7"],
        sectionsColor: ["#FFFFFF", "#FFFFFF", "#F7F9FD", "blue", "white", "#F7F9FD", "#F7F9FD"],
        // verticalCentered: true,
        lockAnchors: true,
        recordHistory: true,
        // navigationPosition: 'right',
        paddingTop: "0px",
        resize: true,
        scrollBar: false,
        // loopBottom: true,
        // navigation: true,
        afterLoad: this.afterLoad,
        // navigationTooltips: ["第一页", "第二页", "第三页"],
      },
      items: [
        { image: require('../assets/img/Product1.png'), title: '大数据推送系统', url: '/Product1s' },
        { image: require('../assets/img/Product2.png'), title: '启秘健康大数据平台', url: '/Product2s' },
        { image: require('../assets/img/Product3.png'), title: '医联体综合管理信息平台', url: '/Product3s' },
        { image: require('../assets/img/Product4.png'), title: '学生精准健康教育及风控平台', url: '/Product4s' },

      ],
      images: [
        require('../assets/img/yndx.png'),
        require('../assets/img/kmlgdx.png'),
        require('../assets/img/kmsya.png')
      ],
      hospitalData: [
        [
          { name: '云南大学' }, { name: '云南省医疗投资集团公司' }, { name: '昆明医科大学' },
          { name: '临沧市卫生健康委' }, { name: '工商银行(金融功能技术支持及金融支持)' }, { name: '中国移动通信集团云南有限公司' },
          { name: '医智云科技(云南)有限公司' }
        ],
        [
          { name: '昆明理工大学' }, { name: '云南省健康医疗大数据中心' }, { name: '云南财经大学' },
          { name: '云南南天电子信息产业股份有限公司' }, { name: '红塔银行(健康管理服务)' }, { name: '中国电信通信集团云南有限公司' },
          { name: '云南达远软件有限公司' }
        ],
        [
          { name: '云南大学附属医院' }, { name: '昆明市延安医院' },
          { name: '云南省第一人民医院' }, { name: '昆明市第三人民医院' }
        ],
        [
          { name: '中国医药集团有限公司' }, { name: '工银安盛人寿保险有限公司' },
          { name: '重庆医药(集团)股份有限公司' }, { name: '云南省智慧城市投资公司' }
        ]
      ],
      mhospitalData: [
        [
          { name: '云南大学' }, { name: '云南省医疗投资集团公司' }, { name: '昆明医科大学' },
          { name: '临沧市卫生健康委' }, { name: '工商银行(金融功能技术支持及金融支持)' }, { name: '中国移动通信集团云南有限公司' },
          { name: '医智云科技(云南)有限公司' }, { name: '云南大学附属医院' }, { name: '昆明市延安医院' },
          { name: '云南省第一人民医院' }, { name: '昆明市第三人民医院' }
        ],
        [
          { name: '昆明理工大学' }, { name: '云南省健康医疗大数据中心' }, { name: '云南财经大学' },
          { name: '云南南天电子信息产业股份有限公司' }, { name: '红塔银行(健康管理服务)' }, { name: '中国电信通信集团云南有限公司' },
          { name: '云南达远软件有限公司' }, { name: '中国医药集团有限公司' }, { name: '工银安盛人寿保险有限公司' },
          { name: '重庆医药(集团)股份有限公司' }, { name: '云南省智慧城市投资公司' }
        ],
      ],
    };
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 1439;
    },
  },
  watch: {
    "$route.query": {
      // immediate: true, // 立即执行
      // deep: true, // 深度侦听复杂类型内变化
      handler (newVal, oldVal) {
        let page = newVal.page;
        if (page) {
          this.tmao(page);
        }
      },
    },
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    window.addEventListener('resize', this.handleResize);
    this.load();
  },
  methods: {
    handleResize () {
      this.$forceUpdate(); // 强制重新计算 isMobile
    },
    load () {
      if (document && document.body) {
        document.body.style.margin = '0px';
        this.originalBodyMargin = document.body.style.margin;
      }
    },
    productPush (url) {
      this.$router.push(url)
    }
  },
};
</script>
<style lang="scss" src="../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.mobile-sections {
  display: none;
}

.home_content {
  position: relative;
}

.bottom {
  height: 70px !important;
}

.top_bg {
  background-image: url("../assets/img/ShouTop.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.about_bg {
  background-image: url("../assets/img/About_us_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.product {
  background-color: #F7F9FD;
}

.honor {
  background-image: url("../assets/img/honor_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.pageCon {
  width: 100%;


  .pageCon_bg {
    padding-top: 70px;
    width: 70%;
    height: 100%;
    margin: auto;
    display: flex;
    gap: 15px;



    .pageLeft {
      flex: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .LeftTit {
        margin-bottom: 20px;

        .Tittext {
          font-weight: bold;
        }

        .whiteFont {
          color: white;
        }

        .blue {
          background-color: #0073d3;
          width: 150px;
          height: 7px;
          margin: 15px 0px;
        }
      }

      .LeftBottom {
        width: 100%;
        height: 70%;
        // margin-top: 2%;

        overflow: hidden;

        .leftImg {
          max-width: 100%;
          height: 100%;
        }

        .hoImg {
          max-width: 100%;
          // height: 100%;
        }

        .container {
          height: 50vh;
          width: 100%;
          overflow: hidden;
        }

        .items-container {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-template-rows: repeat(2, 1fr);
          gap: 15px;
          // height: 90%;
          width: 100%;
          padding: 10px;
          box-sizing: border-box;
          margin: 25px 0px;
        }

        .item {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 60%;
          // border-radius: 5px;
          overflow: hidden;
          margin: 0 auto;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          border-radius: 25px;
        }

        .image-container {
          flex: 1;
          overflow: hidden;
          width: 100%;
        }

        .item-image {
          width: 100%;
          height: 100%;
          // object-fit: cover;
          transition: transform 0.3s ease;
        }

        .item:hover .item-image {
          transform: scale(1.05);
        }

        .title-container {
          background: white;
          padding: 10px 0px;
          text-align: center;
          width: 100%;
        }

        .item-title {
          margin: 0;
          color: black;
          font-size: 14px;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }

        .container {
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .top-section {
          height: 40%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .image-container {
          display: flex;
          justify-content: center;
          gap: 20px;
          max-width: 100%;
        }

        .image-item {
          height: 80%;
          max-width: 30%;
          object-fit: contain;
        }

        .hospital-section {
          height: 40%;
          display: flex;
          padding: 10px 5%;
        }

        .hospital-column {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 0 10px;
        }

        .hospital-name {
          padding: 6px 0;
          font-size: 14px;
        }

        .img_s1 {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
          margin: auto;
        }

        .img_s2 {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
          margin: auto;
        }
      }


    }

    .pageRight {
      flex: 1;
      display: flex;
      align-items: center;

      .abimg {
        max-width: 94%;
        height: 68%;
      }

      .imgs {
        flex-direction: column;
        height: 80%;
        margin-top: 30%;

        .img1 {
          max-width: 100%;
          height: 80%;
        }

      }
    }
  }


}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}


@media (max-height: 800px) {
  .pageCon .pageCon_bg .pageLeft .LeftBottom .items-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: repeat(200px, 1fr);

  }

  .pageCon .pageCon_bg .pageLeft .LeftBottom .img_s1 {
    height: 80%;
    width: 70%;
  }

  .pageCon .pageCon_bg .pageLeft .LeftBottom.img_s2 {
    height: 70%;
    width: 70%;
  }
}

@media (max-height: 600px) {
  .pageCon .pageCon_bg .pageLeft.LeftBottom .items-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: repeat(200px, 1fr);

  }

  .pageCon .pageCon_bg .pageLeft .LeftBottom .img_s1 {
    height: 85%;
    width: 70%;
  }

  .pageCon .pageCon_bg .pageLeft .LeftBottom.img_s2 {
    height: 70%;
    width: 70%;
  }
}

/* 手机端适配 (576px-767px) */
@media (max-width: 1439px) and (min-width: 10px) {
  .pc-sections {
    display: none;
  }

  .mobile-sections {
    width: 100%;
    font-size: 15px;
    display: block;
    overflow-x: hidden; // padding-top: 70px;

    .m_con_bg {
      width: 100%;
      height: 30vh;

    }

    .m_con {
      width: 90%;
      margin: auto;
      // height: 90vh;
      padding: 3vh;
      // overflow-y: auto;

      .m_about {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: calc(100%-6vh);

        .m_about_text {
          flex: 1;
        }

        .m_about_img {
          flex: 1;
          width: 100%;
          height: 70%;
          display: flex;
          justify-content: center;

          img {
            max-width: 50%;
            // height: 70%;
          }
        }
      }

      .m_items-container {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: repeat(2, 1fr);
        gap: 15px;
        height: calc(100%-15px);
        width: 100%;
        // padding: 10px;
        box-sizing: border-box;

        .item {
          display: flex;
          flex-direction: column;
          height: 90%;
          width: 100%;
          // border-radius: 5px;
          overflow: hidden;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .image-container {
          flex: 1;
          overflow: hidden;
          width: 100%;
        }

        .item-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .item:hover .item-image {
          transform: scale(1.05);
        }

        .title-container {
          background: white;
          padding: 10px 0px;
          text-align: center;
          width: 100%;
        }

        .item-title {
          margin: 0;
          color: black;
          font-size: 14px;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
      }

      .m_honor {
        margin-top: 15px;

        .m_honorimg1 {
          max-width: 90%;
        }

        .m_honorimg2 {
          max-width: 80%;
        }

        .m_honorimg3 {
          max-width: 70%;
        }
      }

    }

    .m_container {
      height: calc(100%-15px);
      display: flex;
      flex-direction: column;

      .top-section {
        height: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
      }

      .image-container {
        display: flex;
        gap: 15px;
        flex-direction: column;
        max-width: 60%;
      }

      .image-item {
        // height: 80%;
        max-width: 80%;
        margin: auto;
        object-fit: contain;
      }

      .hospital-section {
        height: 40%;
        display: flex;
        padding: 10px 5%;
      }

      .hospital-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 10px;
      }

      .hospital-name {
        padding: 6px 0;
        font-size: 11px;
      }
    }

    .m_bule_div {

      .blue_tit {
        font-weight: 500;
      }

      .blue_div {
        margin-top: 5px;
        width: 80px;
        height: 5px;
      }

      .blue_color {
        background-color: #0073d3
      }

      .white_color {
        background-color: white
      }

      .white_text {
        color: white
      }
    }
  }


}
</style>
